import React from "react";
import { Box, Paper, Skeleton, Typography, useTheme } from "@mui/material";
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from "@mui/icons-material";
import { useUserInfo } from "../../utils/security";
import { formatCurrency, formatNum } from "../../utils/numbers";
import { isEmpty } from "lodash";

export const TotalsCard = ({ data, currencyCode, title, factor, loading }) => {
    const theme = useTheme();
    const { userInfo } = useUserInfo();

    if (isEmpty(data) || loading) {
        return <Skeleton variant="rectangular" sx={{ flex: 1 }} height={140} />;
    }

    const percent = (data?.diffPercent || 0) * (factor || 1);
    let color = percent > 0 ? "green" : percent < 0 ? "red" : theme.palette.grey["600"];
    return (
        <Box sx={{ flex: 1 }}>
            <Paper sx={{ px: 4, py: 2 }}>
                <Typography variant="body1">{title}</Typography>
                <Box sx={{ display: "flex", alignItems: "end", gap: 2, py: 2 }}>
                    <Typography variant="h5">
                        {formatCurrency(
                            data?.current || 0,
                            currencyCode,
                            userInfo.currencies,
                            2,
                            userInfo.decimalDelimiter,
                            userInfo.thousandDelimiter
                        )}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {data?.diffPercent > 0 && (
                                <ArrowUpwardOutlined sx={{ color, fontSize: "inherit" }} />
                            )}
                            {data?.diffPercent < 0 && (
                                <ArrowDownwardOutlined sx={{ color, fontSize: "inherit" }} />
                            )}
                            {data?.diffPercent > 0 && "+"}
                            {formatNum(
                                data?.diffPercent || 0,
                                2,
                                userInfo.decimalDelimiter,
                                userInfo.thousandDelimiter
                            )}
                            %
                        </Box>
                    </Typography>
                </Box>
                <Typography
                    variant="caption"
                    gutterBottom
                    sx={{ color: theme.palette.grey["600"] }}>
                    Za předchozí období{" "}
                    {formatCurrency(
                        data?.previous || 0,
                        currencyCode,
                        userInfo.currencies,
                        2,
                        userInfo.decimalDelimiter,
                        userInfo.thousandDelimiter
                    )}
                </Typography>
            </Paper>
        </Box>
    );
};
